import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import PublisherPrefixList from "./PublisherPrefixList";
import PublisherPrefixEdit from "./PublisherPrefixEdit";
import PublisherPrefixDetailPage from "./PublisherPrefixDetailPage";
import { PublisherPrefixDeclareLastUsed } from "./PublisherPrefixDeclareLastUsed";
import { RouteGuard } from "../../guards/RouteGuard";
import { RoleEnum } from "../../types/RoleEnum";
function PublisherPrefixes() {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, render: function () { return (React.createElement(RouteGuard, { allowedRoles: [
                    RoleEnum.AGENCY_WORKER,
                    RoleEnum.PUBLISHER_GUARANTOR,
                    RoleEnum.PUBLISHER_ADMIN,
                ] },
                React.createElement(PublisherPrefixList, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/edit/:id"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.AGENCY_WORKER] },
                React.createElement(PublisherPrefixEdit, null))); } }),
        React.createElement(Route, { exact: true, path: "".concat(cleanPath, "/declare-last-used"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [
                    RoleEnum.AGENCY_WORKER,
                    RoleEnum.PUBLISHER_GUARANTOR,
                    RoleEnum.PUBLISHER_ADMIN,
                ] },
                React.createElement(PublisherPrefixDeclareLastUsed, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/detail"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [
                    RoleEnum.AGENCY_WORKER,
                    RoleEnum.PUBLISHER_GUARANTOR,
                    RoleEnum.PUBLISHER_ADMIN,
                ] },
                React.createElement(PublisherPrefixDetailPage, null))); } })));
}
export default PublisherPrefixes;
